export default {
  navigation: {
    homepage: 'Home',
    profile: 'My Profile',
    editProfile: 'Edit My Profile',
    changePassword: 'Change Password',
    devices: 'My Devices',
    services: 'My Services',
    disableAccess: 'Disable access to a platform'
  },
  email: 'Email',
  username: 'Email, phone or identifier (INS, RPPS, ...)',
  password: 'Password',
  newPassword: 'New password',
  firstName: {
    view: 'First name(s)',
    edition: 'First name(s) (e.g. Jim, Mark, Victor)'
  },
  lastName: 'Last name',
  birthName: 'Birth name',
  speciality: 'Specialty',
  category: 'Category',
  address: 'Address',
  type: 'Type',
  phone: 'Mobile phone',
  birthDate: 'Date of birth (DD/MM/YYYY)',
  birthDateUser: 'Date of birth',
  birthPlaceInsee: 'INSEE code of birth city',
  birthDateNotSpecified: 'Not specified',
  phoneNotSpecified: 'Not specified',
  sex: 'Sex',
  sexChoice: {
    male: 'Male',
    female: 'Female',
    unknown: 'Not specified'
  },
  gender: 'Gender',
  ins: 'INS number',
  oid: 'OID',
  parentIns: 'Parent\'s INS number',
  myInformations: 'My personal information',
  contactInformation: 'My contact information',
  information: 'My informations',
  profile: 'My profile',
  passwordChoice: 'Set my password',
  passwordHint: 'Must contain at least 8 characters, including 1 number, 1 lowercase letter, and 1 uppercase letter.',
  patient: {
    label: 'Patient',
    identifier: 'Social security number',
    firstNameUsed: 'First name used',
    lastNameUsed: 'Last name used'
  },
  professional: {
    label: 'Professional',
    identifier: 'Identifier (RPPS, ADELI, other (FINESS, SIRET, SIREN, DRASS))',
    job: 'Job',
    jobSpecialty: 'Specialty'
  },
  trustedDevices: {
    title: 'My Trusted Devices',
    subtitle: 'You will find all of your recognized devices here',
    noDevice: 'No recognized devices',
    refresh: 'Refresh',
    userAgent: 'Device',
    ip: 'IP Address',
    moreDevice: 'See my devices',
    creationDate: 'Added on',
    lastUsed: 'Last used',
    deleteDevice: 'Delete this device',
    alert: {
      title: 'Removing a trusted device',
      content: 'The device "{userAgent}" will no longer be considered trusted and you will have to use two-factor authentication.'
    }
  }
}
